import React, {useEffect} from 'react';
import styles from "./GoogleLoginButton.scss";

export default function GoogleLoginButton() {

	useEffect(() => {

		if (typeof window.renderGoogleLoginButton === 'function') {
			window.renderGoogleLoginButton();
		}

	}, [window.google]);

	return (
		<div id={'googleLoginButton'} className={styles.googleButton}/>
	)
}
